import { render } from "./App.vue?vue&type=template&id=02908829&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=02908829&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=02908829&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02908829"]])

export default __exports__